export default {
  k: 'тыс',
  m: 'млн',
  b: 'млрд',
  t: 'трлн',
  pieces: 'шт',
  kilogram: 'кг',
  meter: 'м',
  cubicMeter: 'м³',
};
